const o = "_accordion_1g2bi_1", c = "_accordion__item_1g2bi_8", _ = "_accordion__header_1g2bi_11", n = "_accordion__content_1g2bi_21", i = "_accordion__button_1g2bi_32", d = {
  accordion: o,
  "accordion--bordered": "_accordion--bordered_1g2bi_5",
  accordion__item: c,
  accordion__header: _,
  accordion__content: n,
  accordion__button: i
};
export {
  o as accordion,
  i as accordion__button,
  n as accordion__content,
  _ as accordion__header,
  c as accordion__item,
  d as default
};
